module.exports = "/templates/bds/public/font/6a004ddb259f02543b250c8467669ea6.ttf";